import React from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { useRouter } from 'next/router';
import SearchInput from '../SearchInput/SearchInput';
import * as Styled from './SearchForm.styled';
import { useConstructorIO } from '../../../../util/ConstructorIO.context';
var SearchFormSchema = Yup.object().shape({
    search: Yup.string().required('')
});
/**
 * SearchForm Component
 */
var SearchForm = function (_a) {
    var onRequestClose = _a.onRequestClose;
    var router = useRouter();
    var _b = useConstructorIO(), query = _b.query, setQuery = _b.setQuery, response = _b.response;
    var handleSubmit = function (values) {
        var _a;
        var search = values.search;
        var cleanSearch = search.replace(/[^a-zA-Z0-9 ]/g, '');
        var hashedSearch = btoa(cleanSearch);
        router.push(((_a = response === null || response === void 0 ? void 0 : response.redirect) === null || _a === void 0 ? void 0 : _a.data.url) || "/search?q=".concat(hashedSearch));
    };
    return (React.createElement(Styled.SearchForm, null,
        React.createElement(Formik, { initialValues: { search: '' }, onSubmit: handleSubmit, validationSchema: SearchFormSchema, validateOnBlur: false, validateOnChange: false },
            React.createElement(Form, { "data-cnstrc-search-form": true },
                React.createElement(SearchInput, { id: "search", name: "search", query: query, refine: function (value) { return setQuery(value); }, onRequestClose: onRequestClose, "data-cnstrc-search-input": true })))));
};
export default SearchForm;
